'use client';

import Link from 'next/link';


export default function CTASection() {
  return (
    <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div
          className="relative rounded-[2.5rem] overflow-hidden p-10 sm:p-16 text-center"
          style={{ background: 'linear-gradient(135deg,#0D1B3E 0%,#1877F2 60%,#162550 100%)' }}>

          {/* Decorative blobs */}
          <div className="absolute top-0 right-0 w-72 h-72 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle,rgba(244,169,35,0.15) 0%,transparent 70%)', transform: 'translate(30%,-30%)' }} />
          <div className="absolute bottom-0 left-0 w-56 h-56 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle,rgba(255,255,255,0.05) 0%,transparent 70%)', transform: 'translate(-30%,30%)' }} />

          <div className="relative z-10">
            {/* Badge */}
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
              style={{ background: 'rgba(244,169,35,0.2)', border: '1px solid rgba(244,169,35,0.35)' }}>

              <span className="w-2 h-2 rounded-full bg-[#F4A923] animate-pulse" />
              <span className="text-[#F4A923] text-xs font-bold tracking-widest uppercase">
                Offre spéciale Côte d'Ivoire
              </span>
            </div>

            <h2
              className="font-heading font-bold text-white mb-4"
              style={{ fontSize: 'clamp(1.8rem,4vw,3rem)', lineHeight: 1.1 }}>

              Prêt à booster votre
              <br />
              <span className="gradient-text-gold">présence social ?</span>
            </h2>

            <p className="text-white/65 mb-8 max-w-lg mx-auto" style={{ fontSize: 15 }}>
              Rejoignez plus de 12 500 clients ivoiriens satisfaits. Commandez maintenant et recevez vos résultats en moins de 24 heures.
            </p>

            {/* Payment methods */}
            <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
              {[
              { label: 'Orange Money', bg: '#FF6600', color: 'white' },
              { label: 'MTN MoMo', bg: '#FFCC00', color: '#0D1B3E' },
              { label: 'Wave', bg: '#1ABCFE', color: 'white' },
              { label: 'Carte Bancaire', bg: 'rgba(255,255,255,0.15)', color: 'white' }]?.
              map((m) =>
              <span
                key={m?.label}
                className="px-3 py-1.5 rounded-full text-xs font-bold"
                style={{ background: m?.bg, color: m?.color }}>

                  {m?.label}
                </span>
              )}
            </div>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/services"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '16px 36px',
                  borderRadius: 50,
                  background: 'linear-gradient(135deg,#F4A923 0%,#E8920F 100%)',
                  color: '#0D1B3E',
                  fontFamily: 'Plus Jakarta Sans,sans-serif',
                  fontWeight: 800,
                  fontSize: 16,
                  textDecoration: 'none',
                  boxShadow: '0 4px 24px rgba(244,169,35,0.4)',
                  transition: 'all 0.3s'
                }}>

                🚀 Commander maintenant
              </Link>
              <a
                href="https://wa.me/2250575956671"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '16px 36px',
                  borderRadius: 50,
                  background: 'rgba(255,255,255,0.1)',
                  color: 'white',
                  fontFamily: 'Plus Jakarta Sans,sans-serif',
                  fontWeight: 600,
                  fontSize: 15,
                  textDecoration: 'none',
                  border: '1.5px solid rgba(255,255,255,0.3)',
                  transition: 'all 0.3s'
                }}>

                💬 WhatsApp Support
              </a>
            </div>

            <p className="text-white/40 text-xs mt-6">
              Sans engagement · Livraison garantie · Support 7j/7
            </p>
          </div>
        </div>
      </div>
    </section>);

}